import {
  EndPointsNames,
  ApiCredentialsType,
  ErrorResponseCodeType,
} from '_core/types';
import { setEntityName } from '_core/util/object';

export const API_DOMAIN: EndPointsNames = 'ApiAccount';
export const ENDPOINT_API_PATH = 'v1/utils/tokens/email';
export const ENTITY_NAME = setEntityName(ENDPOINT_API_PATH);
const API_CREDENTIALS_TYPE: ApiCredentialsType[] = [
  'TOKEN_AUTH_USER',
  'TOKEN_AUTH_USER_OR_CREDENTIALS',
];
const URL_POSTMAN = '#';

export const CODE_ERRORS: ErrorResponseCodeType[] = [
  {
    code: '1',
    bussinessErrorVariant: 'errorService',
    message:
      'Ocorreu um erro técnico (Erro inesperado, favor contactar a Smiles)',
  },
  {
    code: '2',
    bussinessErrorVariant: 'processFailure',
    message: 'Ocorreu um erro ao enviar Email',
  },
  {
    code: '3',
    bussinessErrorVariant: 'tokenExpired',
    message: 'Token inválido ou expirado',
  },
];

export default {
  API_DOMAIN,
  ENDPOINT_API_PATH,
  API_CREDENTIALS_TYPE,
  URL_POSTMAN,
  CODE_ERRORS,
  ENTITY_NAME,
};
